var Model = require('../Model');

var AlarmProfile = Object.create(Model);

AlarmProfile.name = 'AlarmProfile';
AlarmProfile.url = 'alarmprofile';
AlarmProfile['@class'] = 'AlarmProfile';
AlarmProfile.fields = {
  name: {
    validators: {
      presence: true, 
      length: {minimum: 3, maximum: 256, default: ''},
    }
  },
  alarmEnabled: {
    default: 0
  },
  alarmName: {

  },
  alarmDescription: {

  },
  notifyReset: {

  },
  interval : {

  },
  triggers: {
    default: []
  },
  excludedHours: {
    default : []
  },
  excludedDaysOfWeek: {
    default : []
  },
  validHiLimit: {

  },
  validLoLimit: {

  },
  escalationReceivers: {
    default: []
  },
  escalationDelay: {
    default: 0
  },
  sendContinuousNotifications: {
    default: false
  },
  continuousNotificationInterval: {
    default: 300
  }
};

module.exports = AlarmProfile;
